import Icon from '@material-ui/icons/Redeem'
import CouponList from './CouponList'
import CouponShow from '../couponsBases/CouponShow'

export default {
  list: CouponList,
  show: CouponShow,
  icon: Icon,
}
